import { defineMessages } from 'react-intl';

export default defineMessages({
    baVehicle: {
        id: 'endorsement.ba.directives.templates.ba-edit-vehicle.Vehicles',
        defaultMessage: 'Vehicles',
    },
    baNewVehicle: {
        id: 'endorsement.ba.directives.templates.ba-edit-vehicle.New Vehicle',
        defaultMessage: 'New Vehicle',
    },
    baVehicleNotUniqueTitle: {
        id: 'endorsement.ba.controllers.BAPolicyChangeDriverCtrl.VIN is not unique',
        defaultMessage: 'VIN is not unique',
    },
    baVinMatch: {
        id: 'endorsement.ba.controllers.BAPolicyChangeDriverCtrl.VinMatchMsg',
        defaultMessage: 'Sorry, but this vehicle VIN matches that of {vinMatchedVehicle}. Please ensure that all VINs are unique.'
    },
    atleastOneVehicle: {
        id: 'endorsement.ba.controllers.BAPolicyChangeDriverCtrl.You have to have at least one vehicle',
        defaultMessage: 'You have to have at least one vehicle',
    },
    addVehical: {
        id: 'endorsement.ba.views.ba-driver-details.Add Vehicle',
        defaultMessage: 'Add Vehicle'
    },
    addAnotherVehical: {
        id: 'endorsement.ba.views.ba-driver-details.Add Another Vehicle?',
        defaultMessage: 'Add Another Vehicle?'
    },
    addNew: {
        id: 'endorsement.ba.views.ba-driver-details.Add',
        defaultMessage: 'Add'
    },
    removeVehicleTitle: {
        id: 'endorsement.ba.controllers.baVehicleDetailsCtrl.Remove Vehicle?',
        defaultMessage: 'Remove Vehicle?',
    },
    removeVehicleDescription: {
        id: 'endorsement.ba.drivers.remove-vehicle.message',
        defaultMessage: 'Are you sure you want to remove this vehicle from the list of vehicles?',
    },
    substituteVehicle: {
        id: 'endorsement.ba.views.ba-driver-details.Substitute Vehicle',
        defaultMessage: 'Substitute Vehicle'
    }
});
